import { render, staticRenderFns } from "./StadiumCreateAndUpdateFormItems.vue?vue&type=template&id=31820b16&"
import script from "./StadiumCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./StadiumCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31820b16')) {
      api.createRecord('31820b16', component.options)
    } else {
      api.reload('31820b16', component.options)
    }
    module.hot.accept("./StadiumCreateAndUpdateFormItems.vue?vue&type=template&id=31820b16&", function () {
      api.rerender('31820b16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StadiumCreateAndUpdateFormItems.vue"
export default component.exports